/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BillingAddress } from '../models/BillingAddress';
import type { ControllerResponse_boolean_ } from '../models/ControllerResponse_boolean_';
import type { ControllerResponse_Subscription_Array_ } from '../models/ControllerResponse_Subscription_Array_';
import type { ControllerResponse_Subscription_or_null_ } from '../models/ControllerResponse_Subscription_or_null_';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class StripeService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * @returns ControllerResponse_Subscription_Array_ Ok
     * @throws ApiError
     */
    public getCustomerSubscriptions(): CancelablePromise<ControllerResponse_Subscription_Array_> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/stripe/subscriptions',
        });
    }
    /**
     * @param returnUrl
     * @returns any Ok
     * @throws ApiError
     */
    public getCustomerPortal(
        returnUrl: string,
    ): CancelablePromise<{
        data: {
            url: string;
        } | null;
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/stripe/customer_portal',
            query: {
                'return_url': returnUrl,
            },
        });
    }
    /**
     * @returns ControllerResponse_Subscription_Array_ Ok
     * @throws ApiError
     */
    public getChildrenSubscriptions(): CancelablePromise<ControllerResponse_Subscription_Array_> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/stripe/child_subscriptions',
        });
    }
    /**
     * @param subscriptionId
     * @returns ControllerResponse_Subscription_or_null_ Ok
     * @throws ApiError
     */
    public closeChildAccount(
        subscriptionId: string,
    ): CancelablePromise<ControllerResponse_Subscription_or_null_> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/stripe/close_child_account',
            query: {
                'subscriptionId': subscriptionId,
            },
        });
    }
    /**
     * @param subscriptionId
     * @returns ControllerResponse_Subscription_or_null_ Ok
     * @throws ApiError
     */
    public keepChildAccount(
        subscriptionId: string,
    ): CancelablePromise<ControllerResponse_Subscription_or_null_> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/stripe/keep_child_account',
            query: {
                'subscriptionId': subscriptionId,
            },
        });
    }
    /**
     * @param requestBody
     * @returns any Ok
     * @throws ApiError
     */
    public createPropertyReportsSubscription(
        requestBody: {
            address?: BillingAddress;
            promo_code?: string;
            payment_method_id: string;
        },
    ): CancelablePromise<{
        data: {
            subscriptionId: string;
            clientSecret?: string;
        };
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/stripe/create_property_reports_subscription',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns any Ok
     * @throws ApiError
     */
    public createMarketAnalyticsSubscription(): CancelablePromise<{
        data: {
            subscriptionId: string;
        };
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/stripe/create_market_analytics_subscription',
        });
    }
    /**
     * @returns any Ok
     * @throws ApiError
     */
    public createFinancialAnalysisSubscription(): CancelablePromise<{
        data: {
            subscriptionId: string;
        };
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/stripe/create_financial_analysis_subscription',
        });
    }
    /**
     * @param requestBody
     * @returns any Ok
     * @throws ApiError
     */
    public setPaymentMethod(
        requestBody: {
            payment_method_id: string;
        },
    ): CancelablePromise<{
        data: {
            id: string;
        };
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/stripe/set_payment_method',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param promoCode
     * @returns any Ok
     * @throws ApiError
     */
    public checkPromoCodeController(
        promoCode: string,
    ): CancelablePromise<{
        data: {
            id?: string;
            percent_off: number;
            amount_off: number;
            active: boolean;
        };
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/stripe/check_promo_code',
            query: {
                'promoCode': promoCode,
            },
        });
    }
    /**
     * @returns any Ok
     * @throws ApiError
     */
    public propertyReportTrialConsumed(): CancelablePromise<{
        data: boolean;
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/stripe/property_reports_trial_consumed',
        });
    }
    /**
     * @returns ControllerResponse_boolean_ Ok
     * @throws ApiError
     */
    public hasBillingInfo(): CancelablePromise<ControllerResponse_boolean_> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/stripe/has_billing_info',
        });
    }
    /**
     * @returns any Ok
     * @throws ApiError
     */
    public getCustomerApiKeys(): CancelablePromise<{
        data: Array<{
            key: string;
        }>;
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/stripe/get_customer_api_keys',
        });
    }
    /**
     * @returns any Ok
     * @throws ApiError
     */
    public getUpcomingInvoice(): CancelablePromise<{
        data: {
            period_end: number;
            period_start: number;
            amount_due: number;
            total: number;
            discount: {
                name: string | null;
                amount: number;
            } | null;
            subtotal: number;
            lines: Array<{
                nickname?: string | null;
                quantity: number | null;
                description: string | null;
                amount: number;
            }>;
        };
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/stripe/upcoming_invoice',
        });
    }
    /**
     * @param seats
     * @returns any Ok
     * @throws ApiError
     */
    public updateNumberPropertyReportsSeats(
        seats: number,
    ): CancelablePromise<{
        data: number | null;
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/stripe/update_property_reports_seats',
            query: {
                'seats': seats,
            },
        });
    }
    /**
     * @returns ControllerResponse_boolean_ Ok
     * @throws ApiError
     */
    public cancelSubscription(): CancelablePromise<ControllerResponse_boolean_> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/stripe/cancel_subscription',
        });
    }
    /**
     * @returns ControllerResponse_boolean_ Ok
     * @throws ApiError
     */
    public renewSubscription(): CancelablePromise<ControllerResponse_boolean_> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/stripe/renew_subscription',
        });
    }
}
